import axios from 'axios'
import { CRM_API_URL } from '@/constants/api'

function fetchFinalRating (filialId, date) {
    return axios.get(`${CRM_API_URL}/statistic/reviews/rating/final`, {
        params: { filialId, date },
    }).then(response => response.data)
}

function fetchIndicators (filialId, startDate, endDate) {
    return axios.get(`${CRM_API_URL}/statistic/reviews/indicators`, {
        params: { filialId, startDate, endDate },
    }).then(response => response.data)
}

function fetchRatingsStatistics (filialId, startDate, endDate) {
    return axios.get(`${CRM_API_URL}/statistic/reviews/ratings`, {
        params: { filialId, startDate, endDate },
    }).then(response => response.data)
}

function fetchReasonsStatistics (filialId, startDate, endDate) {
    return axios.get(`${CRM_API_URL}/statistic/reviews/reasons`, {
        params: { filialId, startDate, endDate },
    }).then(response => response.data)
}

function fetchUsefulActionsStatistics (filialId, startDate, endDate) {
    return axios.get(`${CRM_API_URL}/statistic/reviews/useful-actions`, {
        params: { filialId, startDate, endDate },
    }).then(response => response.data)
}

export default {
    fetchFinalRating,
    fetchIndicators,
    fetchRatingsStatistics,
    fetchReasonsStatistics,
    fetchUsefulActionsStatistics,
}
